@if (data.title) {
  <bv-dialog-title>{{ data.title }}</bv-dialog-title>
}
<bv-dialog-body class="py-6">
  <bv-form-field [label]="data.message">
    <input bv-input [(ngModel)]="inputValue" (keyup.enter)="onConfirm()" />
  </bv-form-field>
</bv-dialog-body>
<bv-dialog-footer>
  <button bv-button variant="ghost" (click)="onCancel()">
    {{ data.cancelButton || "Cancel" }}
  </button>
  <button bv-button variant="primary" (click)="onConfirm()">
    {{ data.acceptButton || "OK" }}
  </button>
</bv-dialog-footer>
